import { render, staticRenderFns } from "./tabsBar.vue?vue&type=template&id=d54027ec&scoped=true&"
import script from "./tabsBar.vue?vue&type=script&lang=js&"
export * from "./tabsBar.vue?vue&type=script&lang=js&"
import style0 from "./tabsBar.vue?vue&type=style&index=0&id=d54027ec&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54027ec",
  null
  
)

export default component.exports